export default {
  EXPLORE_PROJECTIONS: [
    'afterPhase',
    'beforePhase',
    'categories',
    'coach',
    'collaborators',
    'completedAt',
    'completedBy',
    'contentType',
    'createdAt',
    'description',
    'executedAt',
    'executedBy',
    'expand',
    'impactEndsAt',
    'impactStartsAt',
    'name',
    'organization',
    'owner',
    'relate',
    'review',
    'routine',
    'site',
    'siteGroups',
    'status',
    'tags',
    'validatedReview',
    'validations',
  ],
  EXPLORE_EXPANSIONS: [
    'assignees',
    'coach',
    'collaborators',
    'completedBy',
    'createdBy',
    'organization',
    'owner',
    'routine',
    'site',
    'tags',
  ],
  VIEW_STATES: {
    FILTERS: 'filters',
    LOADING: 'loading',
    IMPORTED: 'imported',
    ERROR: 'error',
    EMPTY: 'empty',
  },
  DEFAULT_COLUMNS_BY_TYPE: {
    improvementIdea: [
      'contentType',
      'title',
      'link',
      'status',
      'validations',
      'location',
      'tags',
      'categories',
      'createdAt',
      'completedAt',
      'owner',
      'coach',
      'collaborators',
      'phases',
      'plan',
      'adjust',
      'review',
    ],
    quickAction: [
      'contentType',
      'title',
      'link',
      'status',
      'validations',
      'location',
      'tags',
      'categories',
      'createdAt',
      'completedAt',
      'owner',
      'coach',
      'collaborators',
      'phases',
      'before',
      'after',
      'review',
    ],
    problemSolving: [
      'contentType',
      'title',
      'link',
      'status',
      'validations',
      'location',
      'tags',
      'categories',
      'createdAt',
      'completedAt',
      'owner',
      'coach',
      'collaborators',
      'phases',
      'define',
      'improveControl',
      'review',
    ],
    finding: [
      'contentType',
      'title',
      'link',
      'priority',
      'status',
      'createdAt',
      'completedAt',
      'assignees',
      'categories',
      'routine',
      'location',
      'tags',
    ],
    routine: [
      'contentType',
      'title',
      'link',
      'status',
      'location',
      'tags',
      'executedBy',
      'description',
      'executedAt',
      'completedAt',
    ],
  },
  DEFAULT_EXPLORE_FILTERS: {
    types: [],
    status: [],
    role: null,
    priority: [],
    condition: [],
    validation: null,
    assignees: [],
    categories: [],
    createdBy: null,
    createdAt: null,
    createdAtOption: null,
    completedAt: null,
    completedAtOption: null,
    dueDate: [],
    dueDateOption: null,
    sites: [],
    siteGroups: [],
    tags: [],
    tagGroups: [],
    countryCodes: [],
    routineDefinitions: [],
    routineType: [],
    situationTypes: [],
    routineDefinitionsPresetFilter: null,
    hasFinancialValidation: null,
    hasImplementationValidation: null,
  },
}
